export class Prenotazione {
  _id?: string;
  // Required
  prestazione: string;
  nome: string;
  inizio: string;
  fine: string;
  isUser: boolean;

  // Nullable
  cognome?: string;
  cellulare?: string;
  prezzo?: number;
  note?: string;
  tempoMedio?: number;
  timer?: string;
  timerEnd?: string;
  abbonamento?: boolean;

  constructor(
    prestazione: string,
    nome: string,
    inizio: string,
    fine: string,
    isUser: boolean,
    _id?: string,
    cognome?: string,
    cellulare?: string,
    prezzo?: number,
    note?: string,
    tempoMedio?: number,
    timer?: string,
    timerEnd?: string,
    abbonamento?: boolean
  ) {
    this._id = _id;
    this.prestazione = prestazione;
    this.nome = nome;
    this.inizio = inizio;
    this.fine = fine;
    this.isUser = isUser;
    this.cognome = cognome;
    this.cellulare = cellulare;
    this.prezzo = prezzo;
    this.note = note;
    this.tempoMedio = tempoMedio;
    this.timer = timer;
    this.timerEnd = timerEnd;
    this.abbonamento = abbonamento;
  }
}
